import { InterestRate } from "src/api-service";

// **************************************************************************
// INTEREST RATE STATE
// **************************************************************************
export interface InterestRateState {
    interestRate: InterestRate | null;
    interestRates: InterestRate[];
    interestRatesLoading: boolean;
}

export const initialInterestRateState: InterestRateState = {
    interestRate: null,
    interestRates: [],
    interestRatesLoading: false,
};
